import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { listItemVariants } from '../../../lib/list-styles'

interface MenuStaticItemProps extends ComponentProps<'div'> {
  className?: string
}

/**
 * A row that states something rather than doing it ("Signed in as jane@acme.com"). The same
 * geometry as Menu.Item, but not a menuitem: no keyboard stop, no hover or press. `role="none"` keeps it
 * out of the menu's item list, where a role-less child would be an unnamed extra entry.
 */
function MenuStaticItem({ className, children, ...props }: MenuStaticItemProps) {
  return (
    <div
      role="none"
      data-slot="list-item"
      className={twMerge(listItemVariants({ tone: 'neutral' }), 'active:bg-transparent', className)}
      {...props}
    >
      {children}
    </div>
  )
}

export { MenuStaticItem }
